import { Paper, Stack, Typography } from "@mui/material";
import { fonts } from "fonts";
import React from "react";
import FileMenu from "./FileMenu";
import { getThemeColor } from "colors";
import FileTypeIcon from "components/files/FileTypeIcon";

export default function FileCard({ file }) {
  return (
    <Paper
      sx={{
        backgroundColor: getThemeColor("box"),
      }}
    >
      <Stack p={2} direction="row" spacing={2} alignItems="center">
        <FileTypeIcon file={file} />
        <Stack
          sx={{
            flexGrow: 1,
          }}
        >
          <Typography color={"text"} fontFamily={fonts.geist}>
            {file.filename}
          </Typography>
          <Typography
            color={"text"}
            fontFamily={fonts.geist}
            variant="caption"
          >
            {new Date(file.createdAt).toLocaleString()}
          </Typography>
        </Stack>
        <FileMenu file={file} color={"text"} />
      </Stack>
    </Paper>
  );
}
